<script>
    export default {
        model: {
            prop: 'courses',
            event: 'update'
        },
        props: [
            'courses-prop',
            'summer-camps-prop',
            'courses',
            'currentItems'
        ],
        data() {
            return {
                items: [],
                isOpened: false
            }
        },
        computed: {
            isEmptyItems() {
                return _.isEmpty(this.items)
            },
            onlyOne() {
                return this.courses.length == 1
            },
            selectedCourse() {
                if (this.courses.length == 1) {
                    return _.head(this.courses)
                }
                return null
            },
            coursesLength() {
                return this.courses.filter(i => i.class_type == 'App\\Course').length
            },
            summerCampsLength() {
                return this.courses.filter(i => i.class_type == 'App\\SummerCamp').length
            }
        },
        mounted() {
            this.fillItems()
        },
        methods: {
            fillItems() {
                this.coursesProp.forEach((i,idx)=> {
                    this.$set(this.coursesProp, idx, Object.assign(i, {
                        class_type: 'App\\Course'
                    }))
                })

                this.summerCampsProp.forEach((i,idx)=> {
                    this.$set(this.summerCampsProp, idx, Object.assign(i, {
                        class_type: 'App\\SummerCamp'
                    }))
                })

                this.items = this.items.concat(this.coursesProp)
                this.items = this.items.concat(this.summerCampsProp)
            },
            isDisabled(course) {
                let idx = _.findIndex(this.currentItems, i => i.id == course.id)
                return idx >= 0
            },
            isSelected(course) {
                let idx = _.findIndex(this.courses, i => i.id == course.id)
                return idx >= 0
            },
            toggleCourseDropdown() {
                if (this.items.length > 0) {
                    this.isOpened = !this.isOpened
                }
            },
            onAddCourse(course) {
                let idx = _.findIndex(this.courses, i => i.id == course.id)
                if (idx >= 0) {
                    this.$emit('update', this.courses.filter((i, index) => index != idx))
                } else {
                    this.$emit('update', [...this.courses, course])
                }
                this.toggleCourseDropdown()
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/MarketingCoursesDropdown.vue